import { wait } from '@/__mocks__/util/async.ts'
import { status } from '@/__mocks__/config.ts'
import {
  clientLevelPage,
  levelsData
} from '@/__mocks__/modules/clientLevels/data.ts'

export default [
  {
    method: 'GET',
    path: '/loyalty/level/catalog',
    reply: async () => {
      await wait()
      return [status.ok, clientLevelPage]
    }
  },
  {
    method: 'GET',
    path: '/loyalty/level',
    reply: async () => {
      await wait()
      return [status.ok, levelsData]
    }
  }
]
